import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="transfer-projects--list"
export default class extends Controller {
  static targets = ["selectableProject"];
  
  connect() {
  }

  selectAllProjects() {
    this.selectableProjectTargets.forEach(e => {
      e.checked = true;
      this.selectProject(undefined, { cb: e });
    });
  }

  deselectAllProjects() {
    this.selectableProjectTargets.forEach(e => {
      e.checked = false;
      this.selectProject(undefined, { cb: e });
    });
  }

  selectProject(event, options={ cb: event?.currentTarget }) {
    if (!options.cb) return;

    const cb = options.cb;
    const tr = cb.closest("tr");

    if (cb.checked) {
      tr.classList.remove("not-selected");
      tr.querySelectorAll(`input:not([type="checkbox"], [name$="[selected]"])`).forEach(e => {
        e.disabled = false;
      });
    } else {
      tr.classList.add("not-selected");
      tr.querySelectorAll(`input:not([type="checkbox"], [name$="[selected]"])`).forEach(e => {
        e.disabled = true;
      });
    }
  }
}
